import { Pipe, PipeTransform } from '@angular/core';
import { Icon, IconItem } from '@sb/library/base';
import { EventLocationIcon } from '@sb/library/data-models';
import { CalendarEventIconManager } from '../calendar-event-icon.manager';

@Pipe({name: 'calendarEventLocationIcon'})
export class CalendarEventLocationIconPipe implements PipeTransform {

    constructor(private _CalendarEventIconManager: CalendarEventIconManager) {
    }

    transform(locationIcon: EventLocationIcon):  IconItem {
        let iconName = this._CalendarEventIconManager.GetEventIconName(locationIcon);
        if (!iconName) {
            iconName = Icon.Common.Location;
        }
        return iconName;
    }
}
